import { useMutation } from "convex/react";

import { Button } from "@/components/ui/button";
import { api } from "@convex/_generated/api";

interface UnsubscribeButtonProps {
  currentSubscription: PushSubscription;
  setCurrentSubscription: (subscription: PushSubscription | null) => void;
}

export const UnsubscribeButton = ({
  currentSubscription,
  setCurrentSubscription,
}: UnsubscribeButtonProps) => {
  const removePushSubscription = useMutation(api.notificationSubscriptions.remove);
  const unsubscribe = async () => {
    try {
      const currentSubscriptionString = JSON.stringify(currentSubscription);
      await currentSubscription.unsubscribe();
      setCurrentSubscription(null);
      await removePushSubscription({ pushSubscription: currentSubscriptionString });
      console.log("Unsubscribed from push notifications");
    } catch (error) {
      console.error("Error unsubscribing from push notifications:", error);
    }
  };

  return (
    <Button onClick={unsubscribe} variant="destructive">
      Unsubscribe from notifications
    </Button>
  );
};
